import React, {useState} from 'react';

import css from './MenuCategoriesComponent.module.css';
import {ButtonCreate} from "../../../ui/ButtonCreate/ButtonCreate";
import {
    MenuCategoriesNewCategoryModal
} from "../settingSectionModals/MenuCategoriesNewCategoryModal/MenuCategoriesNewCategoryModal";
import MenuCategoriesListComponent from "../MenuCategoriesListComponent/MenuCategoriesListComponent";


const MenuCategoriesComponent = () => {
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => {
        setIsOpen(true);
    };


    return (
        <section className={css.wrap}>

            <section className={css.btnBlock}>
                <ButtonCreate onClick={handleClick}/>
            </section>

            <section className={css.listBlock}>
                <MenuCategoriesListComponent/>
            </section>

            {isOpen && <MenuCategoriesNewCategoryModal setIsOpen={setIsOpen}/>}
        </section>
    );
};

export {MenuCategoriesComponent};